import React from 'react';
import { Text, TextInput, View } from 'react-native';
import { ticketColors } from '../../shared/theme/ticketColors';
import { catalogProductFormStyles as styles } from './catalogProductForm.styles';
import type { CatalogProductFormFieldsProps } from './catalogProductFormFields.types';

type Props = Pick<
  CatalogProductFormFieldsProps,
  | 'draft'
  | 'onActiveIngredientChange'
  | 'onUsageTagsChange'
  | 'mobile'
  | 'desktopRail'
>;

export function CatalogProductFormPharmacyFields({
  draft,
  onActiveIngredientChange,
  onUsageTagsChange,
  mobile = false,
  desktopRail = false,
}: Props) {
  return (
    <View style={styles.ticketFormSection}>
      {!desktopRail ? <Text style={styles.ticketFormSectionTitle}>Farmacia</Text> : null}
      <View style={mobile ? styles.fieldGridMobile : styles.fieldGrid}>
        <View style={[styles.ticketFormField, !mobile && styles.fieldGridItem]}>
          <Text style={styles.ticketFormLabel}>Principio activo</Text>
          <TextInput
            style={styles.ticketFormInput}
            value={draft.activeIngredient}
            onChangeText={onActiveIngredientChange ?? (() => {})}
            placeholder="Ej: ibuprofeno, paracetamol"
            placeholderTextColor={ticketColors.ink3}
          />
        </View>
        <View style={[styles.ticketFormField, !mobile && styles.fieldGridItem]}>
          <Text style={styles.ticketFormLabel}>Para qué se usa (separado por coma)</Text>
          <Text style={[styles.ticketFormLabel, { fontSize: 11, opacity: 0.7, fontWeight: '400', marginBottom: 4 }]}>
            Etiquetas del producto. En gastronomía también se usan para filtros de carta (vegano, carne…).
          </Text>
          <TextInput
            style={[styles.ticketFormInput, styles.notesMultiline]}
            value={draft.usageTags}
            onChangeText={onUsageTagsChange ?? (() => {})}
            placeholder="Ej: dolor de cabeza, fiebre, alergia"
            placeholderTextColor={ticketColors.ink3}
            multiline
          />
        </View>
      </View>
    </View>
  );
}
